import React from "react";

export default function WaitlistConfirmedPage() {
  return (
    <div
      className="min-h-screen bg-white text-zinc-900 antialiased flex items-center justify-center px-6 py-16"
      data-testid="waitlist-confirmed-page"
    >
      <div className="max-w-[640px] mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter leading-[1.05]">
          You&rsquo;re on the waitlist 🎸
        </h1>
        <p className="mt-6 text-lg md:text-xl text-zinc-600 leading-relaxed">
          Your email is confirmed.
        </p>
        <p className="mt-4 text-lg md:text-xl text-zinc-600 leading-relaxed">
          I&rsquo;ll let you know when applications for the next Lead Guitar Freedom cohort open.
        </p>
        <p className="mt-4 text-lg md:text-xl text-zinc-600 leading-relaxed">
          You can close this page now.
        </p>
      </div>
    </div>
  );
}
